import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ApiService } from './api.service';

@Injectable({ providedIn: 'root' })
export class SscUserService {

	constructor(
		private apiService: ApiService
	) { }

	submitReview(jobDetail, tcId, tcwId, approveStatus, assignedNextUser) {
		const url = `${environment.userServiceUrl}/api/user/v1/trainingcentre/approve/${tcId}/${tcwId}/${approveStatus}/${assignedNextUser}`;
		return this.apiService.put(url, { jobRoles: jobDetail, status: 'approved' });

	}
	getJobAffiliationAccrediationRequests(pageNo, itemsPerPage) {
		const url = environment.userServiceUrl + '/api/user/v1/trainingcentre/workflow/filter/?pageNo=' + pageNo + '&limit=' + itemsPerPage;
		return this.apiService.get(url);
	}
	getUndergoingDA(queryU) {
		const url = environment.smartServiceURL + '/api/smart/v1/getjobroles?' + queryU;;
		return this.apiService.get(url);
	}

	getJobAffiliationAccrediationRequestsWithFilter(query) {
		const url = environment.userServiceUrl + '/api/user/v1/trainingcentre/workflow/filter/?' + query;
		return this.apiService.get(url);
	}

	getAffilationForm(formId) {
		const url = `${environment.userServiceUrl}/api/user/v1/trainingcentre/${formId}`;
		return this.apiService.get(url);
	}
	getBatchIdDropDown(id, projectFields?) {
		let url = `${environment.userServiceUrl}/api/batch/v1/get/batches/${id}`;
		if (projectFields) {
			url = url.concat(`?projectFields=${projectFields}`);
		}
		return this.apiService.get(url)
	}

	getCandidateIdDropDown(batchId) {
		const url = `${environment.userServiceUrl}/api/batch/v1/get/candidate//ids?batchId=${batchId}&status="BATCH CREATED"`;
		return this.apiService.get(url);
	}

	getCandidateIdDropDownNoPage(batchId, batchType?) {
		const queryParams = {};
		queryParams['limit'] = 100;
		queryParams['page'] = 1;
		let url = `${environment.userServiceUrl}/api/batch/v1/get/candidate//ids?batchId=${batchId}&status="BATCH CREATED"`;
		if (batchType) {
			url += `&batchType=${batchType}`;
		}
		return this.apiService.get(url, queryParams);
	}
	getBatchTypeDropDown(batchId) {
		const url = `${environment.userServiceUrl}/api/batch/v1/getBatchType/batch/${batchId}`;
		return this.apiService.get(url);
	}
	getTcIdDropDown(userName) {
		// const url = `http://localhost:3000/api/user/v1/trainingcentres?query=trainingPartner.userName=${userName}`;
		const URL = `${environment.userServiceUrl}/api/user/v1/trainingcentres?requestee=Training%20Partner`
		// const url = `${environment.userServiceUrl}/api/user/v1/trainingcentres?query=trainingPartner.userName${userName}&noPagination=yes`;
		return this.apiService.get(URL);
	}

	getTcOfTp(tcId) {
		const URL = `${environment.userServiceUrl}/api/user/v1/tp/created/trainingcentres/for/dropdown?tpId=${tcId}`;
		return this.apiService.get(URL);
	}

	genrateSkillCard(canId, batchId, sectorId, jobRoleName, qpCode, version) {
		const encodedQpCode = encodeURIComponent(qpCode)
		const URL = `${environment.pdfGenerate}/api/v1/generatepdfreports/skillcard?candId=${canId}&batchId=${batchId}&sectorId=${sectorId}&jobRoleNm=${jobRoleName}&qpCode=${encodedQpCode}&version=${version}`;
		return this.apiService.get(URL)
	}
	scpwRequest(query) {
		const URL = `${environment.userServiceUrl}/api/user/v1/trainingcentre/ssc/workflow/scpwd?${query}`;
		return this.apiService.get(URL)
	}
	scpwResRequest(query) {
		const URL = `${environment.userServiceUrl}/api/user/v1/trainingcentre/ssc/workflow/scpwd?${query}`;
		return this.apiService.get(URL)
	}

	sscAffilationListingTabDetails(id) {
		const URL = `${environment.userServiceUrl}/api/user/v1/trainingcentre/getallsscworkflowcount?jobRole.sectorId=${id}`
		return this.apiService.get(URL);
	}

	getAllJobrolesData(data) {
		const URL = `${environment.smartServiceURL}/api/smart/v1/trainingcentre/getallundergoingdainspection?sectorID=${data.id}&pageNo=${data.pageno}&limit=${data.limit}&tcId=${data.tcId}`;
		return this.apiService.get(URL);
	}

	DownloadAssessmentCertificate(body) {
		const URL = environment.batchServiceUrl + '/api/v1/cert/certificate?for=trainingPartner';
		return this.apiService.post(URL, body)
	}

	getallundergoingdainspectiontcList(data) {
		const tcId = data.tcId && data.tcId !== null ? data.tcId : ''
		const URL = `${environment.smartServiceURL}/api/smart/v1/trainingcentre/getallundergoingdainspectiontcdata?sectorID=${data.id}&pageNo=${data.pageno}&limit=${data.limit}&tcId=${tcId}`;
		return this.apiService.get(URL);
	}
	getDeletedJobRoles(query) {
		const url = `${environment.smartServiceURL}/api/smart/v1/tc/getDeletedJobRoles?${query}`;
		return this.apiService.get(url);
	}

	getTotalcountEtacpDashboardValue(sectorName) {
		const url = `${environment.sipReportingServiceUrl}/api/v1/report/etacpdashboardvalues?sectorName=${sectorName}`;
		return this.apiService.get(url);
	}
	getTotalCountKpiDashboardValue(sectorName) {
		const url = `${environment.sipReportingServiceUrl}/api/v1/report/kpisdashboardvalues?sectorName=${sectorName}`;
		return this.apiService.get(url);
	}
	getBatchTrackDashboardValues(sectorName) {
		const url = `${environment.sipReportingServiceUrl}/api/v1/report/batchtrackdashboardvalues?sectorName=${sectorName}`;
		return this.apiService.get(url);
	}

	getSCertificateDashboardData(actionUrl) {
		const url = `${environment.sipReportingServiceUrl}/api/v1/report/certificatemarksheettracking${actionUrl}`;
		return this.apiService.get(url);
	}

	getAssessmentDashboardData(actionUrl) {
		const url = `${environment.sipReportingServiceUrl}/api/v1/report/assessmentfee${actionUrl}`;
		return this.apiService.get(url);
	}


	getAssessmentAndInvoiceDropdown() {
		const url = `${environment.sipReportingServiceUrl}/api/v1/report/assessmenttype`;
		return this.apiService.get(url);
	}

	applyFilterForEtacp(body) {
		const URL = environment.sipReportingServiceUrl + '/api/v1/report/etacpfilterdvalues';
		return this.apiService.post(URL, body)

	}
	applyFilterForKpi(body) {
		const URL = environment.sipReportingServiceUrl + '/api/v1/report/kpifilterdvalues';
		return this.apiService.post(URL, body)

	}
	applyFilterForBatchTrack(body) {
		const URL = environment.sipReportingServiceUrl + '/api/v1/report/batchfilterdvalues';
		return this.apiService.post(URL, body)

	}

	applyFilterForCertificateMarksheet(body) {
		const URL = environment.sipReportingServiceUrl + '/api/v1/report/certificateFilter';
		return this.apiService.post(URL, body)
	}

	getAssessmentDashboardFilterData(body) {
		const URL = environment.sipReportingServiceUrl + '/api/v1/report/assessmentFilter';
		return this.apiService.post(URL, body)
	}

	getBatches() {
		const url = `${environment.sipReportingServiceUrl}/api/v1/report/batches`;
		return this.apiService.get(url);
	}

	getSubSchemes(query) {
		const url = `${environment.sipReportingServiceUrl}/api/v1/report/subschemes?schemeName=${query}`;
		return this.apiService.get(url);
	}

	getFinancialYear() {
		const url = `${environment.sipReportingServiceUrl}/api/v1/report/financialyear`;
		return this.apiService.get(url);
	}

	getTpName(query) {
		const url = `${environment.sipReportingServiceUrl}/api/v1/report/tpname?tpName=${query}`;
		return this.apiService.get(url);
	}

	getStateName() {
		const url = `${environment.sipReportingServiceUrl}/api/v1/report/state`;
		return this.apiService.get(url);
	}

	getJobRoles() {
		const url = `${environment.sipReportingServiceUrl}/api/v1/report/jobrole`;
		return this.apiService.get(url);
	}
	getSchemes() {
		const url = `${environment.sipReportingServiceUrl}/api/v1/report/schemes`;
		return this.apiService.get(url);
	}
}
